import React from 'react';

import { TranslatedTextMessage } from './TranslatedTextMessage';

const MissionText = () => (
  <p>
    <TranslatedTextMessage id={'MISSION_TEXT'} />
  </p>
);

export default MissionText;
